import { useState } from 'react';
import { MarkerF } from '@react-google-maps/api';

const EventMapMarker = ({ event, onClick, allowTooltipShown }) => {

  // const [showInfoWindow, setShowInfoWindow] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick(event);
    }
  }

  const handleMouseOver = () => {
    // setShowInfoWindow(true);
  };

  const handleMouseOut = () => {
    // setShowInfoWindow(false);
  };

  const getEventIcon = (event) => {
    const eventDate = new Date(event.startDate);
    const day = eventDate.getDate().toString().padStart(2, "0");
    const month = eventDate.toLocaleString("default", { month: "short" }).toUpperCase();

    const svg =

    `<svg width="75" height="93" viewBox="0 0 75 93" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.7425 12.0777C23.5965 -3.0623 47.1015 -4.1113 62.2445 9.7397C77.3895 23.5967 78.4325 47.1047 64.5805 62.2457L37.1605 92.2167L9.7425 62.2457C-3.2475 48.0427 -3.2475 26.2757 9.7425 12.0777Z" fill="black"/>
        <text x="50%" y="40%" text-anchor="middle" font-family="Helvetica Neu,Arial, sans-serif" font-size="20" font-weight="bold" fill="#5CC244">${day}.</text>
        <text x="50%" y="58%" text-anchor="middle" font-family="Helvetica Neu,Arial, sans-serif" font-size="12" font-weight="bold" fill="#5CC244">${month}</text>
      </svg>
    `;

    return {
      url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
      scaledSize: new window.google.maps.Size(75, 92),
    };
  };

  return (
    <>
      <MarkerF
      position={{ lat: event.lat, lng: event.lng }}
      icon={getEventIcon(event)}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      zIndex={event.active ? 999 : 1}
      />
      {/* {showInfoWindow && allowTooltipShown && (
        <InfoWindowF position={{ lat: event.lat, lng: event.lng }} options={{ zIndex: 5, pixelOffset: new window.google.maps.Size(0, -47), headerDisabled: true }}>
          <div>{event.name}</div>
        </InfoWindowF>
      )} */}
    </>
  );
};

export default EventMapMarker;
